import { render, staticRenderFns } from "./LinkOffIcon.vue?vue&type=template&id=6a2a51df"
import script from "./LinkOffIcon.vue?vue&type=script&lang=js"
export * from "./LinkOffIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports